// extracted by mini-css-extract-plugin
module.exports = {"text":"ToastLinkContent_text__V9o7f","link":"ToastLinkContent_link__m1NHX"};